import { render, staticRenderFns } from "./IdiomEditor.vue?vue&type=template&id=06b099d4&scoped=true&"
import script from "./IdiomEditor.vue?vue&type=script&lang=js&"
export * from "./IdiomEditor.vue?vue&type=script&lang=js&"
import style0 from "./IdiomEditor.vue?vue&type=style&index=0&id=06b099d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b099d4",
  null
  
)

export default component.exports